// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editCommentModal__kRmfN {
  width: 720px;
  min-height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 850px) {
  .editCommentModal__kRmfN {
    width: 100%;
    height: 98%;
    max-width: 595px;
  }
}

.modalBody__FT3Lk {
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  padding: 25px 25px 0;
}

.commentInfo__tION9 {
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.userImage__zwEqo {
  width: 38px;
  height: 38px;
  border-radius: 50%;
}

.userName__ce3Db {
  font-size: 14px;
  line-height: 17px;
  color: var(--tables-title-text);
}

.commentDate__slKEa {
  font-size: 12px;
  line-height: 16px;
  color: var(--tables-primary-row-text-additional);
  margin-top: 5px;
}

.modalFooter__aTf2r {
  padding: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modalDeleteBtn__dWuQN {
  color: var(--legend-for-header-critical);
}

.modalFooterBtns__hFRIm {
  display: flex;
  align-items: center;
  column-gap: 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditCommentModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EAPF;IAQI,WAAA;IACA,WAAA;IACA,gBAAA;EAxEF;AACF;;AA2EA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,oBAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,iBAAA;EACA,+BAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,wCAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editCommentModal {\n  width: 720px;\n  min-height: 700px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-width: 850px) {\n    width: 100%;\n    height: 98%;\n    max-width: 595px;\n  }\n}\n\n.modalBody {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n  padding: 25px 25px 0;\n}\n\n.commentInfo {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n}\n\n.userImage {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n}\n\n.userName {\n  font-size: 14px;\n  line-height: 17px;\n  color: var(--tables-title-text);\n}\n\n.commentDate {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--tables-primary-row-text-additional);\n  margin-top: 5px;\n}\n\n.modalFooter {\n  padding: 25px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modalDeleteBtn {\n  color: var(--legend-for-header-critical);\n}\n\n.modalFooterBtns {\n  display: flex;\n  align-items: center;\n  column-gap: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editCommentModal": `editCommentModal__kRmfN`,
	"modalBody": `modalBody__FT3Lk`,
	"commentInfo": `commentInfo__tION9`,
	"userImage": `userImage__zwEqo`,
	"userName": `userName__ce3Db`,
	"commentDate": `commentDate__slKEa`,
	"modalFooter": `modalFooter__aTf2r`,
	"modalDeleteBtn": `modalDeleteBtn__dWuQN`,
	"modalFooterBtns": `modalFooterBtns__hFRIm`
};
module.exports = ___CSS_LOADER_EXPORT___;
